import { inject, Injectable } from '@angular/core';
import { rmaShareReplay } from '@rma/generic/rxjs/operators';
import { PublicUserContextService } from '@rma/public/accounts/user';
import { distinctUntilChanged, map, Observable, switchMap } from 'rxjs';
import { toSnakeCase } from '../snake-case/snake-case';
import { ChatApiService } from './chat-api.service';

@Injectable({
  providedIn: 'root',
})
export class ChatContextService {
  private readonly chatApiService = inject(ChatApiService);
  private readonly userService = inject(PublicUserContextService);

  // hacky memoization
  private data$?: Observable<Record<string, unknown>>;

  public get userChatData$(): Observable<Record<string, unknown>> {
    if (!this.data$) {
      this.data$ = this.getCurrentUserChatData();
    }
    return this.data$;
  }

  private getCurrentUserChatData(): Observable<Record<string, unknown>> {
    return this.userService.currentUser$.pipe(
      map((x) => x?.userId),
      distinctUntilChanged(),
      switchMap(() => this.chatApiService.getUserChatData()),
      map((res) => (res ? this.keysToSnakeCase(res) : {})),
      rmaShareReplay(),
    );
  }

  // a fix to get intercom working quickly while we discuss a better way of handling responses
  private keysToSnakeCase(input: Record<string, unknown>) {
    if (typeof input === 'object') {
      const initial: Record<string, unknown> = {};
      return Object.keys(input).reduce((obj, key) => ({ ...obj, [toSnakeCase(key)]: input[key] }), initial);
    }
    return input;
  }
}
